// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qj-0";